<template>
	<el-row class="container">
		<!-- E-learning 平台 -->
		<el-col :span="24" class="header">
			<el-col :span="8" @click.native="homeHub('Home')">
				<img src="../assets/icon/logo.png" alt="L" class="logo-title-area">
			</el-col>
			<el-col :span="8" v-show="showSearchBar">
				<el-form :inline="false" autocomplete="on">
					<el-form-item>
						<input type="search" name="search" autocomplete="on" v-model="searchKeyword" placeholder="主題、關鍵字、編號搜尋" class="input-info" v-on:keydown.enter.prevent='prevent'>
							<!-- <img v-show="searchKeyword.trim().length > 0" src="../assets/icon/ic_clear.png" alt="C" class="clear-icon" @click="clearSearchKeyword">	 -->
							<img src="../assets/icon/ic_search.png" class="input-icon" alt="Submit"  @click="search()">		
					</el-form-item>
				</el-form>
			</el-col>
			<el-col :span="8" v-if="showCourseSearchBar">
				<el-form :inline="false" autocomplete="on">
					<el-form-item>
						<input type="search" name="search" autocomplete="on" v-model="courseKeyword" placeholder="主題、關鍵字、編號搜尋" class="input-info" v-on:keydown.enter.prevent='prevent'>
							<img v-show="courseKeyword.trim().length > 0" src="../assets/icon/ic_clear.png" alt="C" class="clear-icon" @click="clearCourseKeyword">	
							<img src="../assets/icon/ic_search.png" class="input-icon" alt="Submit"  @click="courseSearch()">		
					</el-form-item>
				</el-form>
			</el-col>
			<el-col :span="8" v-if="$store.state.nowStatus === 7">
				<el-form :inline="false" autocomplete="on">
					<el-form-item>
						<input type="search" 
									 name="searchAccount" 
									 autocomplete="on" 
									 v-model="$store.state.accountList.keyword" 
									 placeholder="搜尋會員帳號或姓名" 
									 class="input-info" 
									 v-on:keydown.enter.prevent='prevent'>
							<img v-show="$store.state.accountList.keyword.trim().length > 0" src="../assets/icon/ic_clear.png" alt="C" class="clear-icon" @click="clearAccountSearch()">			
							<img src="../assets/icon/ic_search.png" class="input-icon" alt="Submit"  @click="searchAccount()">		
					</el-form-item>
				</el-form>
			</el-col>
			<el-col :span="8" class="userinfo">
				<el-dropdown v-if="this.externalLinkList.length>0" trigger="hover">
					<span class="userinfo-inner">
						友站連結
					</span>
					<el-dropdown-menu slot="dropdown" class="menu-area">
						<div v-for="obj in externalLinkList" :key="obj.id">
							<el-dropdown-item style="text-align: center; color: #626874">
								<a class="el-dropdown-item" target="_blank" v-bind:href="obj.link">
								{{ obj.title }}
								</a>
							</el-dropdown-item>
						</div>	
					</el-dropdown-menu>
				</el-dropdown>
				<span class="userinfo-inner" @click="homeHub('Course')"> 我的課程 </span>
				<span class="userinfo-inner" @click="homeHub('Favorite')"> 我的最愛 </span>
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner"> 
						<el-badge :is-dot="$store.state.regDot" ><img src="../assets/icon/ic_user.png"/></el-badge>
					</span>
					<el-dropdown-menu slot="dropdown" class="menu-area">
						<div v-if="this.$store.state.isBackendMode">
							<div v-if="this.$store.state.isSystemAdminMode">
								<el-dropdown-item @click.native="homeHub('Department')" style="text-align: center; color: #626874">部門管理
								</el-dropdown-item>
							</div>
							<div>
								<el-dropdown-item  @click.native="homeHub('AccountList')" style="text-align: center; color: #626874">帳號管理
								</el-dropdown-item>
							</div>
							<div>
								<el-dropdown-item  @click.native="homeHub('RegApproval')" style="text-align: center; color: #626874">
									<div v-if="$store.state.regDot">
										<span style="padding-left:13px">註冊審查</span>
										<el-badge is-dot style="right:5px" />
									</div>
									<div v-else>
										註冊審查
									</div>
								</el-dropdown-item>
							</div>
							<el-dropdown-item @click.native="homeHub('Report')" style="text-align: center; color: #626874">統計報表
							</el-dropdown-item>
						</div>
						<div v-if="false">
							<el-dropdown-item @click.native="homeHub('Category')" style="text-align: center; color: #626874">主題分類
							</el-dropdown-item>
						</div>
						<el-dropdown-item @click.native="homeHub('Profile')" style="text-align: center; color: #626874">個人資訊
						</el-dropdown-item>
						<div>
							<el-dropdown-item @click.native="homeHub('Setting')" style="text-align: center; color: #626874">其他設定
							</el-dropdown-item>
						</div>
						<el-dropdown-item @click.native="logout" style="text-align: center; color: #626874">登出
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		
		<!-- Vice BAR-->
		<!-- CategoryBar -->
		<el-col v-if="showCategoryBar" :span="24">
			<el-row class="menu-bar unselectable categoryGroup-bar">
				<div v-for="(categoryGroup, index) in categoryOrder" :key="categoryGroup.id" class="menu-item categoryGroup-item"
				:class="categoryGroup.id === activeCategoryGroup ? 'categoryGroup-active' : ''" @click="selectCategoryGroup(categoryGroup.id, index)" >
				{{categoryGroup.name}}
				<div class="triangle"></div>
			</div>
			</el-row>
			<el-row v-if="activeCategoryGroup" class="menu-bar unselectable category-bar">
				<div v-for="category in categoryList" :key="category.id" class="menu-item category-item"
					:class="category.id === activeCategory ? 'category-active' : ''" @click="selectCategory(category.id)" >
					{{category.title}}
				</div>
			</el-row>
		</el-col>
		<!-- 詳情頁 -->
		<el-col v-else-if="this.$store.state.nowStatus === 1" :span="24" class="vice-bar">
			<div v-if="this.$store.state.isSystemAdminMode || 
			          (this.$store.state.isBackendMode && this.$store.state.infoActualDepId && (this.$store.state.infoActualDepId === this.$store.state.userActualDepId))">
				<el-button class="edit-btn" @click="editFile">編輯
					<img src="../assets/icon/ic_edit_white.png" alt="E" class="edit-icon">
				</el-button>
				<el-button class="delete-btn" @click="deleteFile">刪除
					<img src="../assets/icon/ic_delete_blue.png" alt="D" class="delete-icon">
				</el-button>
			</div>
			<div class="back-title" @click="goPath(0, 'pre')" >
				{{ backText }}
				<div class="back-icon">{{backIcon}}</div>
			</div>
			<div :class="this.$store.state.isSystemAdminMode || 
			            (this.$store.state.isBackendMode && this.$store.state.infoActualDepId && (this.$store.state.infoActualDepId === this.$store.state.userActualDepId)) ? 
									'admin-tab-title':'tab-title'">
				<div v-if="!this.$store.state.resourceList.author && $store.state.editResourceBreadcrumbs.length > 1"
					 style="margin:0px auto; display:inline-flex;">
					<div @click="goPath($store.state.editResourceBreadcrumbs[0].id, 'categoryGroup')" 
						class="path-title">{{$store.state.editResourceBreadcrumbs[0].name}}
						<div class="path-icon">{{pathIcon}}</div>
					</div>
					<div @click="goPath($store.state.editResourceBreadcrumbs[1].id, 'category')" 
						class="path-title">{{$store.state.editResourceBreadcrumbs[1].name}}
						<div class="path-icon">{{pathIcon}}</div>
					</div>
					<div class="path-title">{{$store.state.editResourceBreadcrumbs[2]}}
					</div>
				</div>
			</div>
		</el-col>
		<!-- 編輯新增資源（部門管理員） -->
		<el-col v-else-if="this.$store.state.nowStatus === 2 && this.$store.state.isBackendMode" :span="24" class="vice-bar" style="display:block">
			<el-button class="cancel-btn"  @click="cancelFile" :disabled="this.$store.state.isCancelBtnDisabled">取消
			</el-button>
			<el-button id="save-file" class="save-btn" @click="saveFile" :disabled="this.$store.state.isBtnProcessing">儲存
			</el-button>
		</el-col>
		<!-- 部門組織（系統管理員） -->
		<el-col v-else-if="this.$store.state.nowStatus === 10 && this.$store.state.isSystemAdminMode" :span="24" class="vice-bar" style="display:block">
			<div class="header-title">部門管理</div>
		</el-col>
		<!-- 主題分類（系統管理員） -->
		<el-col v-else-if="this.$store.state.nowStatus === 3 && this.$store.state.isSystemAdminMode" :span="24" class="vice-bar" style="display:block">
			<div class="header-title">主題分類</div>
		</el-col>
		<!-- 線上瀏覽 -->
		<el-col v-else-if="this.$store.state.nowStatus === 5 || this.$store.state.nowStatus === 6" :span="24" class="vice-bar" style="display:block">
			<div class="back-title" @click="homeHub('Info')" >
				{{ backText }}
				<div class="back-icon">{{backIcon}}</div>
			</div>
		</el-col>
		<!-- 會員帳號管理 -->
		<el-col v-else-if="this.$store.state.nowStatus === 7" :span="24" class="vice-bar" style="display:block">
			<div class="header-title">{{ accountPath[0] }}</div>
		</el-col>
		<!-- 註冊審查 -->
		<el-col v-else-if="this.$store.state.nowStatus === 15" :span="24" class="vice-bar" style="display:block">
			<div class="header-title">註冊審查</div>
		</el-col>
		<!-- 統計報表 -->
		<el-col v-else-if="this.$store.state.nowStatus === 13" :span="24" class="vice-bar" style="display:block">
			<div class="header-title">統計報表</div>
		</el-col>
		<!-- 個人資訊 -->
		<el-col v-else-if="this.$store.state.nowStatus === 8" :span="24" class="vice-bar" style="display:block">
			<div class="header-title">個人資訊</div>
		</el-col>
		<!-- 會員帳號新增 -->
		<el-col v-else-if="this.$store.state.nowStatus === 9 && this.$store.state.accountList.status === 2" :span="24" class="vice-bar" style="display:block">
			<div style="margin: 0px 42%; position: absolute;">
				<el-button class="cancel-btn" @click="cancelAccount(true)">取消</el-button>
				<el-button class="save-btn" @click="saveAccount(true)">新增</el-button>
			</div>
			<div :key="0" 
			     class="path-title" 
					 @click="returnAccount(0)">
					 {{accountPath[0]}}
				<div class="path-icon">
					{{pathIcon}}
				</div>
			</div>
			<div :key="1" 
			     class="path-title" 
					 style="width:auto" 
					 @click="returnAccount(1)">
					 {{accountPath[1]}}
			</div>
		</el-col>
		<!-- 會員帳號編輯 -->
		<el-col v-else-if="this.$store.state.nowStatus === 9 && this.$store.state.accountList.status === 3" :span="24" class="vice-bar" style="display:block">
			<div style="margin: 0px 42%; position: absolute;">
				<el-button class="cancel-btn" @click="cancelAccount(false)">取消</el-button>
				<el-button class="save-btn" @click="saveAccount(false)">儲存</el-button>
			</div>
			<div :key="0" 
			     class="path-title" 
					 @click="returnAccount(0)">
					 {{accountPath[0]}}
				<div class="path-icon">
					{{pathIcon}}
				</div>
			</div>
			<div :key="1" 
			     class="path-title" 
					 style="width:auto" 
					 @click="returnAccount(1)">
					 {{$store.state.editAccount.displayName}}
			</div>
		</el-col>
		<!-- 其他設定（系統管理員） -->
		<el-col v-else-if="this.$store.state.nowStatus === 11" :span="24" class="vice-bar" style="display:block">
			<div class="header-title">其他設定</div>
		</el-col>
		<!-- Vice BAR END -->
		<el-col :span="24" class="main" :class="styleWithBar">
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col class="content-wrapper-info">
						<transition name="fade" mode="out-in">
							<router-view @setURL="setURL" @setAuthorList="setAuthorList"
							 	:collegeList="categoryGroupList" :categoryGroupList="categoryGroupList"
								@getCategoriesGroup="getCategoriesGroup"
							 	:categories="categoriesForProps"></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
		<hint v-show="hint.display && this.$store.state.hintStatus.home" :message="hint.message" @close="closeHint"></hint>
	</el-row>
</template>

<script>
	import API from '../api/api';

	export default {
		data() {
			return {
				externalLinkList: [],
				categoryGroupList: [],
				categoryOrder: [],
				categoryList: [],
				categories: [],
				categoriesForProps: [],
				paths: [],
				backText: '返回',
				pathIcon: ' > ',
				backIcon: ' < ',
				searchKeyword: '',
				courseKeyword: '',
				hint: {
					message: '',
					display: false,
				},
				timer: null,
				accountPath: ['會員帳號管理', '新增帳號'],
				activeCategoryGroup: null,
				activeCategory: null,
				activeCategoryTmp: null,
			}
		},
		computed: {
			showSearchBar() {
				// if (this.$store.state.nowStatus === 0 
				// || (this.$store.state.nowStatus === 1 && this.$store.state.entrance === null)) {
				// 	if(this.$store.state.resourceList.author ===  null) {
				// 		return true
				// 	}
				// }
				// global search everywhere
				switch (this.$store.state.nowStatus) {
					case 0:
					case 1:
					case 12:
					case 14:
						return true;
					default:
						return false;
				}
			},
			showCourseSearchBar() {
				// if (this.$store.state.nowStatus === 14 
				// || (this.$store.state.nowStatus === 1 && this.$store.state.entrance === "course")) {
				// 	return true
				// }
				// no course search
				return false;
			},
			showCategoryBar() {
				if (this.$store.state.nowStatus === 0 
				&& this.$store.state.resourceList.author ===  null) {
					return true
				} else if (this.$store.state.nowStatus === 12) {
					return true
				}
				return false;
			},
			styleWithBar() {
				if (this.$store.state.nowStatus === 0) {
					if (this.$store.state.resourceList.author) {
						return "headerWithoutBar";
					} else if (this.activeCategoryGroup) {
						return "headerWith2Bar";
					}
				} else if (this.$store.state.nowStatus === 12) {
					if (this.activeCategoryGroup) {
						return "headerWith2Bar";
					}
				} else if (this.$store.state.nowStatus === 14 || this.$store.state.nowStatus === 16) {
					return "headerWithoutBar";
				}
				return "headerWith1Bar";;
			},
		},
		methods: {
			logout: function () {		
				var _this = this;
				this.$confirm('確定登出嗎 ?', '提示', {
					confirmButtonText: '確定',
          			cancelButtonText: '取消',
				}).then(() => {
					this.$store.dispatch('setHasIcivicLogin', null);
					if(location.pathname === '/') {
						foxdrive_api.logout(location.origin);
  					} else {
						foxdrive_api.logout(location.origin + location.pathname);
					}	
				}).catch(() => {

				});
			},
			homeHub(dest) {
				this.removeWatermark();
				this.clearSearchKeywordState();

				// block event if route to the same vue
				if((this.$store.state.nowStatus === 14 && dest === "Course") ||
					(this.$store.state.nowStatus === 16 && dest === "Favorite")) {
					return;
				}

				// remove entrance state if user route to new path
				if (dest != "Info") {
					this.clearEntranceState();
				}

				switch (dest) {
					case "Home":
					default:
						this.resetStateToHome();
						this.$router.push({ path: '/trend'});
						break;
					case "AccountList":
						this.$store.state.accountList.status = 0;
						this.$router.push({ path: '/account/key=' });
						break;
					case "RegApproval":
						this.$router.push({ path: '/regApproval' });
						break;
					case "Category":
						this.$router.push({ path: '/category' });
						break;
					case "Course":
						this.$router.push({ path: '/course' });
						break;
					case "Favorite":
						this.$router.push({ path: '/favorite' });
						break;
					case "Department":
						this.$router.push({ path: '/department' });
						break;	
					case "Info":
						let id = Number(location.hash.split('/')[2].split('&')[0]);
						this.$router.push({ path: '/info/' +  id});	
						break;
					case "Profile":
						this.$router.push({ path: '/profile' });
						break;
					case "Report":
						this.$router.push({ path: '/report' });
						//window.open("http://issbg.efoxconn.com:81/kibana/goto/cebe735c70cfdcc4291553eda402914a", '_blank');
						break;
					case "Setting":
						this.$router.push({ path: '/setting' });
						break;
				}
			},
			goPath: function(id, type) {
				// < 返回
				if(type === 'pre') {
					if (this.$store.state.entrance) {
						if (this.$store.state.entrance === "course") {
							this.$router.push({ path: '/course'});
						} else if (this.$store.state.entrance === "personalReport") {
							this.$router.push({ path: '/report'});
						} else if (this.$store.state.entrance === "favorite") {
							this.$router.push({ path: '/favorite'});
						} else {
							this.homeHub('Home');
						}
						return;
					} else if (this.$store.state.resourceList.categoryId === null && 
					 this.$store.state.resourceList.categoryGroupId === null &&
					 this.$store.state.resourceList.author === null &&
					 this.$store.state.resourceList.keyword === '') {
						this.$router.push({ path: '/trend'});
						return;
					}
				} else {
					this.clearEntranceState();
				}

				if(type === 'category') {
					// 麵包屑 - category
					this.clearResourceListState();
					this.clearSearchKeywordState();
					this.$store.state.resourceList.categoryId = id;
					this.updateCategoryBarStatus();
				} else if (type === 'categoryGroup') {
					// 麵包屑 - categoryGroup
					this.clearResourceListState();
					this.clearSearchKeywordState();
					this.$store.state.resourceList.categoryGroupId = id;
					this.updateCategoryBarStatus();
				} else if(type === 'home') {
					// 類別選單bar
					this.clearResourceListState();
					this.clearSearchKeywordState();
					if (Number(id) === 0 && this.activeCategoryGroup) {
						this.$store.state.resourceList.categoryGroupId = this.activeCategoryGroup;
					} else {
						this.$store.state.resourceList.categoryId = Number(id);
					}
				}

				this.setURL();
			},
			editFile: function() {
				let id = location.hash.split('/')[2];
				this.$router.push({ path: '/edit/' +  id});	
			},
			deleteFile: function() {
				var _this = this;
				this.$confirm('確定刪除此筆資源嗎 ?', '提示', {
					confirmButtonText: '確定',
          			cancelButtonText: '取消',
					//type: 'warning'
				}).then(() => {
					let completeTimes = 0;
					for(let i = 0 ; i < this.$store.state.editResourceId.length ; i++) {
						//delete temp file
						API.deleteResource(this.$store.state.editResourceId[i]).then((response) => {
							if(response.status) {
								redirectLogin(response.data);
								if(!JSON.parse(response.request.response).error_msg) {
									this.showHint('刪除資源錯誤!');
								} else {
									this.showHint(JSON.parse(response.request.response).error_msg);	
								}
							} else {
								if (this.$store.state.editResourceFileAttrs[i].length > 0) {
									for(let j = 0 ; j < this.$store.state.editResourceFileAttrs[i].length ; j++) {
										//delete true file
										API.deleteResourceFromJustup(this.$store.state.editResourceFileAttrs[i][j].fileid).then((result) => {
											completeTimes++;
											if(result.status) {
												redirectLogin(result.data);
												if(!JSON.parse(result.request.response).error_msg) {
													this.showHint('刪除資源錯誤!');
												} else {
													this.showHint(JSON.parse(result.request.response).error_msg);
												}
											} else {
												if(completeTimes === this.$store.state.editResourceId.length) {
													this.setURL();	
													this.showHint('刪除資源成功');		
												}
											}
										});
									}			
								} else {
									completeTimes++;
									if(completeTimes === this.$store.state.editResourceId.length) {
										this.setURL();	
									}
								}
							}
						});
					}
				}).catch(() => {

				});
			},
			/**
			  * cancelFile 取消資源編輯
			  * @return none
			  */
			cancelFile: function() {
				if(this.$store.state.editResourceId[0]) {									
					if(!isEqual(this.$store.state.tempEditResourceFileAttrsIds, this.$store.state.editResource.fileIds)) {
						this.showHint('編輯過後必須先儲存');
    					return;	
					}
					this.$router.push({ path: '/info/' + this.$store.state.editResourceId[0]});	
				} else {
					this.$confirm('尚未儲存新增成功，確定取消嗎 ?', '提示', {
						confirmButtonText: '確定',
          				cancelButtonText: '取消',
					}).then(() => {
						this.setURL();	
					}).catch(() => {

					});	
				}	

				function isEqual(value, other) {

					// Get the value type
					var type = Object.prototype.toString.call(value);

					// If the two objects are not the same type, return false
					if (type !== Object.prototype.toString.call(other)) return false;

					// If items are not an object or array, return false
					if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

					// Compare the length of the length of the two items
					var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
					var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
					if (valueLen !== otherLen) return false;

					// Compare two items
					var compare = function (item1, item2) {

						// Get the object type
						var itemType = Object.prototype.toString.call(item1);

						// If an object or array, compare recursively
						if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
							if (!isEqual(item1, item2)) return false;
						}
						// Otherwise, do a simple comparison
						else {
							// If the two items are not the same type, return false
							if (itemType !== Object.prototype.toString.call(item2)) return false;

							// Else if it's a function, convert to a string and compare
							// Otherwise, just compare
							if (itemType === '[object Function]') {
								if (item1.toString() !== item2.toString()) return false;
							} else {
								if (item1 !== item2) return false;
							}
						}
					};

					// Compare properties
					if (type === '[object Array]') {
						for (var i = 0; i < valueLen; i++) {
							if (compare(value[i], other[i]) === false) return false;
						}
					} 
					// If nothing failed, return true
					return true;
				};
			},
			/**
			  * saveFile 更新資源
			  * @return none
			  */ 
			saveFile: function() {
				if(this.$store.state.editResourceId[0]) { 
					if(this.checkResourceItem()) {
						if(this.$store.state.isCheckSave) {
							this.$store.state.isBtnProcessing = true;
							//fix file
							API.fixResource(this.$store.state.editResourceId[0], this.$store.state.editResource).then((response) => {
								this.$store.state.isBtnProcessing = false;
								if(response.status) {
									redirectLogin(response.data);
									if(!JSON.parse(response.request.response).error_msg) {
										this.showHint('儲存資源錯誤!');
									} else {
										this.showHint(JSON.parse(response.request.response).error_msg);
									}
								} else {
									this.setURL();	
									this.showHint('儲存資源成功!');
								}
							});
						} else {
							this.showHint('檔案尚未上傳成功，還無法儲存，請稍等...');
							return;		
						}
					}
				} else {
					if(this.checkResourceItem()) {
						if(this.$store.state.isCheckSave) {
							this.$store.state.isBtnProcessing = true;
							//add file
							API.addResource(this.$store.state.editResource).then((reply) => {
								this.$store.state.isBtnProcessing = false;
								if(reply.status) {
									redirectLogin(reply.data);
									if(!JSON.parse(reply.request.response).error_msg) {
										this.showHint('新增檔案錯誤!');
									} else {
										this.showHint(JSON.parse(reply.request.response).error_msg);
									}
								} else {
									this.showHint('新增檔案成功!');
									this.$store.state.editResourceId.push(reply.resourceId);	
									this.setURL();	
								}
							});
						} else {
							this.showHint('檔案尚未上傳成功，還無法新增，請稍等...');
							return;	
						}						
					}
				}
			},
			checkResourceItem() {
				if(this.$store.state.editResource.title === '') {
    			this.showHint('標題不能為空');	
    			return false;	
				}

				if(this.$store.state.editResource.description === '') {
					this.showHint('簡介不能為空');
    			return false;	
				}
					
				if(this.$store.state.editResourceFileAttrs.length === 0) {
					this.showHint('您未選取檔案上傳');
    			return false;	
				}

				return true;
			},
			/**
			  * getExternalLinks 取得友站連結
			  * @return ExternalLink
			  */  
			  getExternalLinks() {
				API.getExternalLinks().then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得友站連結資訊錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);
						}
					} else {
						this.externalLinkList.splice(0);
						this.externalLinkList = response.result;
					}
				});
			},
			/**
			  * getCategories 取得主題分類
			  * @return none
			  */  
			getCategories() {
				API.getCategories().then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得主題分類資訊錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);
						}
					} else {
						this.categoriesForProps.splice(0);
						this.categoriesForProps = response.result;
						this.categories.splice(0);
						let defaultAll = {};
						defaultAll.id = 0;
						defaultAll.title = '全部';
						defaultAll.code = 'all';
						this.categories.push(defaultAll);
						for(let i = 0 ; i < response.result.length ; i++) {
							this.categories.push(response.result[i]);
						}
					}
				});
			},
			getCategoriesGroup() {
				API.getCategoriesGroup().then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('取得學院列表資訊錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);
						}
					} else {
						this.categoryGroupList.splice(0);
						this.categoryGroupList = response.result;
						this.$store.state.categoryGroupReady = true;
					}
				});
			},
			getCategoryOrder() {
				API.getCategoryOrder('user').then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.$message.error('取得分類排序發生錯誤!');
						} else {
							this.$message.error(JSON.parse(response.request.response).error_msg);
						}
					} else {
						this.categoryOrder.splice(0);
						this.categoryOrder = response.result;
						let defaultAll = { 
							'id': 0,
							'name': '全部',
							'category': [],
						};
						this.categoryOrder.unshift(defaultAll);
						this.updateCategoryBarStatus();
					}
				});
			},
			updateCategoryBarStatus() {
				this.resetCategoryBar();
				if (this.$store.state.resourceList.categoryGroupId || this.$store.state.resourceList.categoryId) {	
					for(let i = 0 ; i < this.categoryOrder.length ; i++) {
						if (this.categoryOrder[i].id === this.$store.state.resourceList.categoryGroupId ) {
							this.selectCategoryGroup(this.categoryOrder[i].id, i);
							this.activeCategory = 0;
						} else {
							for (let j = 0 ; j < this.categoryOrder[i].category.length ; j++) {
								if (this.categoryOrder[i].category[j].id === this.$store.state.resourceList.categoryId) {
									this.selectCategoryGroup(this.categoryOrder[i].id, i);
									this.activeCategory = this.categoryOrder[i].category[j].id;
								}
							}
						}
					}
				}
			},
			setAuthorList(author, authorName) {
				this.clearResourceListState();
				this.clearSearchKeywordState();
				this.clearEntranceState();

				this.$store.state.resourceList.author = author;
				this.$store.state.resourceList.authorName = authorName;

				this.setURL();
			},
			/**
			  * setURL 設定要前往的URL
			  * @return none
			  */ 
			setURL() {	
				let url = '/table/';

				if(this.$store.state.resourceList.categoryGroupId){
					url = url + '&categoryGroupId=' + this.$store.state.resourceList.categoryGroupId;
				}

				if(this.$store.state.resourceList.categoryId){
					url = url + '&categoryId=' + this.$store.state.resourceList.categoryId;
				}

				if(this.$store.state.resourceList.actual_depid) {
					url = url + '&actual_depid=' + this.$store.state.resourceList.actual_depid;
				}

				if(this.$store.state.resourceList.level) {
					url = url + '&level=' + this.$store.state.resourceList.level;
				}

				if(this.$store.state.resourceList.type) {
					url = url + '&type=' + this.$store.state.resourceList.type;
				}

				if(this.$store.state.resourceList.author) {
					url = url + '&author=' + this.$store.state.resourceList.author;
				}

				if(this.$store.state.resourceList.authorName) {
					url = url + '&authorName=' + encodeURIComponent(this.$store.state.resourceList.authorName);
				}

				if(this.$store.state.resourceList.startTime) {
					url = url + '&start=' + this.$store.state.resourceList.startTime;
				}

				if(this.$store.state.resourceList.endTime) {
					url = url + '&end=' + this.$store.state.resourceList.endTime;
				}

				if(this.$store.state.resourceList.secret) {
					url = url + '&secret=' + this.$store.state.resourceList.secret;
				}

				if(this.$store.state.resourceList.tag) {
					url = url + '&tag=' + encodeURIComponent(this.$store.state.resourceList.tag);
				}

				url = url + '&keyword=' + this.$store.state.resourceList.keyword;
				this.searchKeyword = this.$store.state.resourceList.keyword;

				this.$router.push({ path: url});
			},
			removeWatermark() {
				if((this.$store.state.nowStatus === 5 || this.$store.state.nowStatus === 6) && this.$store.state.isSystemAdminMode === false) {
					if (document.getElementById('_waterMark')) {
						document.getElementsByClassName('main')[0].removeChild(document.getElementById('_waterMark'));
					}
				}
			},
			resetStateToHome() {
				//this.clearResourceListAllState();
				this.clearResourceListState();
				this.resetCategoryBar();
				this.clearSearchKeywordState();

				if (this.$store.state.isCategoryUpdated) {
					this.getCategories();
					this.getCategoriesGroup();
					this.getCategoryOrder();
					this.$store.state.isCategoryUpdated = false;
				}
			},
			clearResourceListAllState() {
				this.clearResourceListState();
				this.clearEntranceState();

				this.$store.state.resourceList.actual_depid = null;
				this.$store.state.resourceList.level = null;
				this.$store.state.resourceList.type = null;
				this.$store.state.resourceList.startTime = null;
				this.$store.state.resourceList.endTime = null;

				this.$store.state.resourceList.order = null;
				this.$store.state.resourceList.by = null;

				this.$store.state.resourceList.secret = null;

				this.clearCheckFilterState();
				this.clearSearchKeywordState();
			},
			clearResourceListState() {
				this.$store.state.resourceList.categoryId = null;
				this.$store.state.resourceList.categoryGroupId = null;
				this.$store.state.resourceList.currentPage = 1;
				this.$store.state.resourceList.offset = 0;
				this.$store.state.resourceList.tag = null;

				this.clearAuthorState();
			},
			resetCategoryBar() {
				this.activeCategoryGroup = null;
				this.activeCategory = null;
				this.activeCategoryTmp = null;
			},
			clearAuthorState() {
				this.$store.state.resourceList.author = null;
				this.$store.state.resourceList.authorName = null;
			},
			clearCheckFilterState() {
				this.$store.state.isShowCheckFilter = false;
				this.$store.state.checkedFilterLists = [];
				this.$store.state.checkedDeps = null;
  				this.$store.state.checkedLevels = [];
  				this.$store.state.checkedTypes = [];
  				this.$store.state.checkedTimes = null;
			},
			clearSearchKeywordState() {
				this.$store.state.resourceList.keyword = '';
				this.$store.state.isHaveSearchKeyword = false;
				this.searchKeyword = '';
			},
			clearSearchKeyword: function() {
				this.clearSearchKeywordState();
				this.$store.state.resourceList.currentPage = 1;
				this.$store.state.resourceList.offset = 0;
				
				this.setURL();
			},
			clearEntranceState() {
				this.$store.state.entrance = null;
				this.clearCourseListState();
				this.clearFavoriteState();
				this.clearReportState();
			},
			clearCourseListState() {
    			this.$store.state.course.listStatus.type = null;
				this.$store.state.course.listStatus.depid = null;
    			this.$store.state.course.listStatus.actual_depid = null;
    			this.$store.state.course.listStatus.order = null;
				this.$store.state.course.listStatus.by = null;
				this.$store.state.course.listStatus.currentPage = 1;
				this.$store.state.course.listStatus.offset = 0;
				
				this.clearCourseKeywordState();
			},
			clearCourseKeywordState() {
				this.courseKeyword = '';
				this.$store.state.course.keyword = '';
			},
			clearCourseKeyword: function() {
				this.$store.state.course.listStatus.currentPage = 1;
				this.$store.state.course.listStatus.offset = 0;

				this.clearCourseKeywordState();
				this.$router.push({ path: '/course' });
			},
			clearFavoriteState() {
				this.$store.state.favorite.listStatus.order = null;
            	this.$store.state.favorite.listStatus.by = null;
				this.$store.state.favorite.listStatus.currentPage = 1;
				this.$store.state.favorite.listStatus.offset = 0;
				this.$store.state.favorite.listStatus.total = 0;
			},
			clearReportState() {
				this.$store.state.report.selectedDepId = null;
				this.$store.state.report.dateRange = null;
				this.$store.state.report.isShowPersonalDetail = false;
				this.$store.state.report.personalListStatus.id = null;
            	this.$store.state.report.personalListStatus.name = null;
				this.$store.state.report.personalListStatus.pagination.current_page = 1;
				this.$store.state.report.personalListStatus.pagination.offset = 0;
				this.$store.state.report.detailListStatus.pagination.current_page = 1;
				this.$store.state.report.detailListStatus.pagination.offset = 0;
			},
			clearAccountSearch: function() {
        		this.$store.state.accountList.keyword = '';
				this.$router.push({ path: '/account/key=' });
			},
			prevent: function(e) {
				// Return / Enter
    			if(e.keyCode === 13) {
					//e.preventDefault();
					// if(this.$store.state.nowStatus === 0) {
					// 	this.search();
					// } else if(this.$store.state.nowStatus === 7) {
					// 	this.searchAccount();
					// } else if(this.$store.state.nowStatus === 14) {
					// 	this.courseSearch();
					// } else if(this.$store.state.nowStatus === 1) {
					// 	if (this.$store.state.entrance === "course") {
					// 		this.courseSearch();
					// 	} else {
					// 		this.search();
					// 	}
					// }
					// global search everywhere
					switch (this.$store.state.nowStatus) {
						case 0:
						case 1:
						case 12:
						case 14:
							this.search();
							break;
						case 7:
							this.searchAccount();
							break;
						default:
							break;
					}
    			}		
      		},
			search: function() {
				if(this.searchKeyword.trim() === '') {
					return;
				} else {
					this.$store.state.resourceList.keyword = this.searchKeyword.replace(/\//g, "");
					this.$store.state.resourceList.keyword = this.searchKeyword.trim();	
				}
				
				this.clearResourceListState();
				this.resetCategoryBar();
				this.clearEntranceState();
					
				this.setURL();
			},
			courseSearch: function() {
				this.$store.state.course.keyword = this.courseKeyword;
				this.$store.state.course.listStatus.currentPage = 1;
				this.$store.state.course.listStatus.offset = 0;
				this.$router.push({ path: '/course' });
			},
			searchAccount: function() {
				if(this.$store.state.accountList.keyword.trim() === '') {
					this.$store.state.accountList.keyword = '';	
				} else {
					this.$store.state.accountList.keyword = this.$store.state.accountList.keyword.replace(/\//g, "");
					this.$store.state.accountList.keyword = this.$store.state.accountList.keyword.trim();	
				}
				this.$router.push({ path: '/account/key=' +  this.$store.state.accountList.keyword});
			},
      		/**
			  * closeHint close hint 視窗
			  * @return none
			  */
			closeHint: function() {
				this.hint.display = false;
				this.$store.state.hintStatus.home = false;
				clearTimeout(this.timer);
			},
			/**
			  * showHint 
			  * @param  {string} message - message
			  * @return none
			  */
			showHint: function(message) {
				if(this.timer) {
					clearTimeout(this.timer);	
				}
				this.hint.display = true;
				this.hint.message = message;	
				this.$store.state.showHint= true;
				this.$store.state.hintStatus.home = true;
				this.timer = setTimeout(()=>{
					if(this.$store.state.showHint) {
						this.$store.state.showHint = false;
						this.$store.state.hintStatus.home = false;
					}
				}, this.$store.state.fadeOutTime);
			},
			selectCategoryGroup(id, index) {
				this.categoryList.splice(0);
				if (this.activeCategoryGroup === id) {
					this.activeCategoryGroup = null;
					this.activeCategoryTmp = this.activeCategory;
					return;
				} else {
					this.activeCategoryGroup = id;
					this.categoryList = JSON.parse(JSON.stringify(this.categoryOrder[index].category));
					this.categoryList.unshift({
						id: 0,
						code: "all",
						title: "全部"
					});
					
					if (this.activeCategoryTmp && this.categoryList.find(cat => cat.id === this.activeCategoryTmp)) {
						this.activeCategory = this.activeCategoryTmp;
					} else {
						this.activeCategory = 0;
					}
					this.activeCategoryTmp = null;
				}
				
				this.goPath(this.activeCategory, 'home');
			},
			selectCategory(id) {
				this.activeCategory = id;
				this.goPath(id, 'home');
			},
			/**
			  * cancelAccount 取消編輯/新增帳號
			  * @return none
			  */
			cancelAccount: function(isAdd) {
				let title = "";
				if(isAdd) {
					title = "新增";
				} else {
					title = "儲存";
				}
				this.$confirm('您尚未' + title +'成功，確定取消嗎 ?', '提示', {
					confirmButtonText: '確定',
          			cancelButtonText: '取消',
				}).then(() => {
					this.$store.state.accountList.status = 4;
					this.$router.push({ path: '/account/key=' +  this.$store.state.accountList.keyword});			
				}).catch(() => {

				});	
			},
			/**
			  * returnAccount 回到會員管理
			  * @return none
			  */
			returnAccount: function(index) {
				if(index === 0) {
					this.cancelAccount();
				}
			},	
			/**
			  * saveAccount 新增/儲存會員帳號
			  * @return none
			  */
			saveAccount: function(isAdd) {
				if(!this.$store.state.editAccount.displayName || !this.$store.state.editAccount.name ||
				   	!this.$store.state.editAccount.email || this.$store.state.editAccount.password === ''||
					!this.$store.state.editAccount.actual_depid ) {
					this.showHint('請檢查是否有選項為空');
					return;
				}

				// 檢查密碼強度
				const regex = /^(?=\S{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).*$/;
				if (!regex.test(this.$store.state.editAccount.password)) {
					this.showHint('密碼須至少8位，並包含大小寫字母、數字及特殊字元');
					return;
				}

				if(this.$store.state.editAccount.password !== this.$store.state.editAccount.checkPassword) {
					this.showHint('密碼輸入需一致');
					return;	
				}

				if(isAdd) {
					API.addAccount(this.$store.state.editAccount).then((response) => {
						if(response.status) {
							redirectLogin(response.data);
							if(!JSON.parse(response.request.response).error_msg) {
								if (JSON.parse(response.request.response).error_code=== "ERROR_SCIENCE_EXCLUDE_OVER_LIMIT") {
									this.showHint('不列入統計的會員人數達到上限!');
								} else {
									this.showHint('修改會員帳號錯誤!');
								}
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							this.showHint('新增會員成功!');
							this.$store.state.accountList.status = 4;
							this.$router.push({ path: '/account/key=' +  this.$store.state.accountList.keyword});	
						}
					});
				} else {
					API.editAccount(this.$store.state.editAccount).then((response) => {
						if(response.status) {
							redirectLogin(response.data);
							if(!JSON.parse(response.request.response).error_msg) {
								if (JSON.parse(response.request.response).error_code=== "ERROR_SCIENCE_EXCLUDE_OVER_LIMIT") {
									this.showHint('不列入統計的會員人數達到上限!');
								} else {
									this.showHint('修改會員帳號錯誤!');
								}
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							this.showHint('修改會員成功!');
							this.$store.state.accountList.status = 4;
							this.$router.push({ path: '/account/key=' +  this.$store.state.accountList.keyword});	
						}
					});
				}
			},		
		},
		beforeCreate() {	
			let _this = this;
			//取得使用者資訊
			API.getUser().then((result) => {
				if(result.status) {
					redirectLogin(result.data);
					if(!JSON.parse(result.request.response).error_msg) {
						this.showHint('取得使用者資訊錯誤!');
					} else {
						this.showHint(JSON.parse(result.request.response).error_msg);
					}
				} else {
					//update username
					this.$store.state.userName = result.name;
					//取得管理者權限
					API.accountInfo(this.$store.state.userName).then((response) => {
						if(response.status !== 0 && response.status !== 1) {
							redirectLogin(response.data);
							if(response.status === 403) {
								this.$alert('您目前使用的帳號並非 E-learning 平台的帳號，會導致您無法瀏覽任何資料，請使用您的工號重新登入', '警告', {
									confirmButtonText: '確定',
								}).then(() => {
									if(location.pathname === '/') {
										foxdrive_api.logout(location.origin);
									} else {
										foxdrive_api.logout(location.origin + location.pathname);
									}
								});
							}
							return;
						} else {
							this.$store.state.userDepId = response.depId;
							this.$store.state.userActualDepId = response.actual_depid;
							if(response.isManager === 2) {
								this.$store.state.isSystemAdminMode = true;
								this.$store.state.isBackendMode = true;
							} else if(response.isManager === 1) {
								this.$store.state.isSystemAdminMode = false;
								this.$store.state.isBackendMode = true;
							} else {
								this.$store.state.isSystemAdminMode = false;
								this.$store.state.isBackendMode = false;	
							}
							this.$store.state.userInfoReady = true;

							if(this.$store.state.isBackendMode) {
								let dep = this.$store.state.isSystemAdminMode ? null : this.$store.state.userActualDepId;
								API.getRegisterList(dep).then((response) => {
									if(response.status) {
										console.error(response);
									} else {
										let regList = response.filter(x => x.status === null);
										if (regList.length > 0) {
											this.$store.state.regDot = true;
										} else {
											this.$store.state.regDot = false;
										}
									}
								});
							}
							//檢查是否需要重設密碼
							if (result.needResetPwd) {
								let pwdLength = this.$store.state.isSystemAdminMode === true ? 12 : 8;
								this.$alert('因資安要求加強密碼規則，請您重新設定密碼以符合密碼強度：\n' +
								`1.必須至少包含${pwdLength}個字元\n` + 
								'2.必須至少包含1個大寫字母 (A-Z)\n' + 
								'3.必須至少包含1個小寫字母 (a-z)\n' + 
								'4.必須至少包含1個數字 (0-9)\n' + 
								'5.必須至少包含1個特殊符號 (! @ # $ % ^ & * ( ) _ + - = [ ] { } | \')\n' + 
								'6.每季需更換一次密碼',
								'提示', 
								{
									confirmButtonText: '確定',
									closeOnClickModal: false,
									closeOnPressEscape: false,
									showClose: false,
									customClass: 'alert-pre-line'
								}).then(() => {
									_this.$router.push({ path: '/profile' });
								});
							}
						}
					});	
					this.getExternalLinks();
				}
			});


			let path = location.hash.split('/')[1];
			let id = location.hash.split('/')[2];

			if(path === 'table' && id) {

				if(id.toString().includes("categoryGroupId=")) {
					this.$store.state.resourceList.categoryGroupId = Number(id.toString().split('categoryGroupId=')[1].split('&')[0]);
					if(!this.$store.state.resourceList.categoryGroupId || this.$store.state.resourceList.categoryGroupId === 0) {
						this.$store.state.resourceList.categoryGroupId = null;
					}
				} else {
					this.$store.state.resourceList.categoryGroupId = null;	
				}
				
				if(id.toString().includes("categoryId=")) {
					this.$store.state.resourceList.categoryId = Number(id.toString().split('categoryId=')[1].split('&')[0]);
					if(!this.$store.state.resourceList.categoryId || this.$store.state.resourceList.categoryId === 0) {
						this.$store.state.resourceList.categoryId = null;
					}
				} else {
					this.$store.state.resourceList.categoryId = null;	
				}

				if(id.toString().includes("actual_depid=")) {
					this.$store.state.resourceList.actual_depid = Number(id.toString().split('actual_depid=')[1].split('&')[0]);
					if(isNaN(this.$store.state.resourceList.actual_depid)) {
						this.$store.state.resourceList.actual_depid = null;	
					}
				} else {
					this.$store.state.resourceList.actual_depid = null;	
				}
	
				if(id.toString().includes("level=")) {
					this.$store.state.resourceList.level = Number(id.toString().split('level=')[1].split('&')[0]);
					if(isNaN(this.$store.state.resourceList.level)) {
						this.$store.state.resourceList.level = null;	
					}
				} else {
					this.$store.state.resourceList.level = null;	
				}

				if(id.toString().includes("type=")) {
					this.$store.state.resourceList.type = id.toString().split('type=')[1].split('&')[0];
				} else {
					this.$store.state.resourceList.type = null;
				}

				if(id.toString().includes("author=")) {
					this.$store.state.resourceList.author = id.toString().split('author=')[1].split('&')[0];
				} else {
					this.$store.state.resourceList.author = null;
				}

				if(id.toString().includes("authorName=")) {
					let authorName = id.toString().split('authorName=')[1].split('&')[0];
					this.$store.state.resourceList.authorName = decodeURIComponent(authorName);
				} else {
					this.$store.state.resourceList.authorName = null;
				}
	
				if(id.toString().includes("start=")) {
					this.$store.state.resourceList.startTime = Number(id.toString().split('start=')[1].split('&')[0]);
					if(isNaN(this.$store.state.resourceList.startTime)) {
						this.$store.state.resourceList.startTime = null;	
					}
				} else {
					this.$store.state.resourceList.startTime = null;
				}

				if(id.toString().includes("end=")) {
					this.$store.state.resourceList.endTime = Number(id.toString().split('end=')[1].split('&')[0]);
					if(isNaN(this.$store.state.resourceList.endTime)) {
						this.$store.state.resourceList.endTime = null;	
					}
				} else {
					this.$store.state.resourceList.endTime = null;
				}

				if(id.toString().includes("secret=")) {
					this.$store.state.resourceList.secret = Number(id.toString().split('secret=')[1].split('&')[0]);
					if(isNaN(this.$store.state.resourceList.secret)) {
						this.$store.state.resourceList.secret = null;	
					}
				} else {
					this.$store.state.resourceList.secret = null;
				}

				if(id.toString().includes("tag=")) {
					this.$store.state.resourceList.tag = decodeURI(id.toString().split('tag=')[1].split('&')[0]);
				} else {
					this.$store.state.resourceList.tag = null;
				} 

				if(id.toString().includes("keyword=")) {
					this.$store.state.resourceList.keyword = decodeURI(id.toString().split('keyword=')[1]);
				} else {
					this.$store.state.resourceList.keyword = '';
				} 
			}

			if(id) {
				this.$router.push({ path: '/' + path + '/' +  id});
			} else {
				if(path === 'category' || path === 'edit' || path === 'profile' 
				|| path === 'department' || path === 'setting' || path === 'report'|| path === 'course'
				|| path === 'favorite' || path === 'regApproval') {
					this.$router.push({ path: '/' + path + '/' });
				} else {
					this.$router.push({ path: '/trend' });
				}	
			}
		},
		created() {
			this.$store.state.nowStatus = 12;
			if(this.$store.state.resourceList.keyword) {
				this.searchKeyword = this.$store.state.resourceList.keyword;
			}
			this.getCategoriesGroup();
			this.getCategoryOrder();
		},
		mounted() {
			//取得主題分類列表
			this.getCategories();
		}
	}
</script>

<style lang="scss">
	@import '~scss_vars';
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		background-color: #F5F8FA;
		.header {
			//display: inline-flex;
			//flex-wrap: nowrap;
			height: 82px;
			width: 100%;
			background: #1D2327;
			position: fixed;
			.userinfo {
				text-align: right;
				padding-right: 30px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					font-size: 16px;
					margin-top: 30px;
					margin-left: 20px;
					display: inline-block;
    				vertical-align: middle;
					img {
						width: 32px;
						height: 32px;
						border-radius: 20px;
						margin-left:15px;
						float: right;
						margin-top: -7px;
					}
				}
			}
			.input-info {
				-webkit-appearance: none;
				font-size: 16px;
				margin-top: 17px;
				height:48px;
				display: flex;
				width: 100%;
				vertical-align: middle;
				text-align:left;
				align-items: center;
				background-color: #fff;
				background-image: none;
				border-radius: 4px;
				border: 1px solid #bfcbd9;
				box-sizing: border-box;
				outline: 0;
				padding: 3px 10px;
				position:relative;
			}
			input::-ms-clear {
				display: none;
				height: 0;
				width: 0;
			}
			input[type="search"]::-webkit-search-cancel-button {
  				display: none;
			}
			.clear-icon {
				position: absolute;
				display: flex;
				vertical-align: middle;
				width: 26px;
				height: 26px;
				position:relative;
				margin-top: -36px;
				margin-right: 36px;
				float: right;
				cursor: pointer;
			}
			.input-icon {
				position: absolute;
				display: flex;
				vertical-align: middle;
				width: 26px;
				height: 26px;
				position:relative;
				margin-top: -36px;
				margin-right: 6px;
				float: right;
				cursor: pointer;
				background-size: cover;
			}
			.logo-title-area {
				display: inline-block;
				vertical-align: middle;
				height: 100%;
				font-size: 20px;
				color: #FFF;
				margin-top: 16px;
				margin-left: 35px;
				cursor: pointer;
				/*width: 70%;*/
				background-size: cover;
			}
		}

		.unselectable {
			-webkit-user-select: none; /* Safari */        
			-moz-user-select: none; /* Firefox */
			-ms-user-select: none; /* IE10+/Edge */
			user-select: none; /* Standard */
		}

		.menu-bar {
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 8px 6px -10px black;

			.menu-item {
				height: 48px;
				line-height: 48px;
				font-size: 16px;
				padding-left: 25px;
				padding-right: 25px;
				cursor: pointer;	
			}
		}

		.categoryGroup-bar {
			margin-top: 80px;
			background-color: white;

			.categoryGroup-item:hover {
				background-color: #F0F7FF;
				color: #2E90F4;
			}

			.categoryGroup-active {
				color: #2E90F4;

				.triangle {
					margin: 0 auto;
					margin-top: -10px;
					width: 0;
					height: 0;
					border-width: 0 10px 10px;
					border-style: solid;
					border-color: transparent transparent #2E90F4;
				}
			}
		}

		.category-bar {
			background-color: #2E90F4;
			color: white;

			.category-item:hover {
				border-bottom: 4px solid white;
			}

			.category-active {
				border-bottom: 4px solid white;
			}
		}

		.vice-bar {
			border-color: #F5F8FA;
			text-align: center;
			width: 100% !important;
			position: absolute;
			/*height: 48px;*/
			border-width: 1px;
			border-style: solid;
			list-style: none;
			background-color: #fff;
			box-shadow: 0 8px 6px -10px black;;
  			display: block;
			float: left;
			margin-top: 80px;
  			justify-content: left;
			white-space: nowrap;
			z-index: 3;
			.path-title {
				font-size: 16px;
				display: block;
				margin-top: 8px;
				color: #222;
				margin-left: 30px;
				float: left;
				height: 36px;
				cursor: pointer;
				.path-icon {
					text-align: center;
					font-size: 16px;
					text-decoration: none;
					display: inline-block;
					margin-top: 8px;
					color: #979797;
					margin-left: 10px;
				}
			}
			.path-title:last-child {
				color: #2E90F4;	
				line-height:36px;
				width:55%;
				overflow : hidden;
  				text-overflow : ellipsis;
  				white-space : nowrap;
			}
			.back-title {
				font-size: 16px;
				display: block;
				margin-top: 16px;
				color: #2E90F4;
				margin-left: 20px;
				float:left;
				height: 36px;
				cursor: pointer;

				.back-icon {
					text-align: center;
					font-size: 16px;
					float: left;
					text-decoration: none;
					display: block;
					/*margin-top: 4px;*/
					color: #979797;
					margin-left: 20px;
					margin-right: 20px;
				}
			}
			.admin-tab-title {
				margin:0px auto; 
				display:inline-flex; 
				width: 65%;
			}
			.tab-title {
				margin:0px auto 0px -6%; 
				display:inline-flex; 
				width: 65%;
			}
			.header-title {
				font-size: 16px;
				display: block;
				margin-top: 12px;
				color: #000;
				margin-left: 35px;
				float:left;
				height: 36px;
			}
			.edit-btn {
				float: right;
				display: block;
				background: #2E90F4;
				border-radius: 2px;
				color: #fff;
				font-size: 14px;
				height: 36px;
				margin-top: 8px;
				border: 1px solid #2E90F4;
				margin-right: 34px;
				white-space: normal;
				width: 92px;
				.edit-icon {
					height: 14px;
					width: 14px;
					float: left;
				}
			}	
			.edit-btn:hover {
				background: #42A0FF;
			}	
			.delete-btn {
				float: right;
				display: block;
				background: #fff;
				border-radius: 2px;
				color: #2E90F4;
				font-size: 14px;
				height: 36px;
				margin-top: 8px;
				margin-right: 20px;
				white-space: normal;
				border: 1px solid #2E90F4;
				width: 92px;
				.delete-icon {
					height: 14px;
					width: 14px;
					float: left;
				}
			}	
			.delete-btn:hover {
				border: 1px solid #42A0FF;
			}		
			.cancel-btn {
				display: inline-block;
				background: #fff;
				border-radius: 2px;
				color: #2E90F4;
				font-size: 14px;
				height: 36px;
				margin-top: 6px;
				margin-bottom: 10px;
				border: 1px solid #2E90F4;
				width: 92px;
			}
			.cancel-btn:disabled {
				color: #fff;
				background-color: gray;
			}
			.cancel-btn:hover {
				border: 1px solid #42A0FF;
			}
			.save-btn {
				display: inline-block;
				background: #2E90F4;
				border-radius: 2px;
				color: #fff;
				font-size: 14px;
				height: 36px;
				margin-top: 6px;
				margin-bottom: 10px;
				border: 1px solid #2E90F4;
				width: 92px;
			}	
			.save-btn:hover {
				background: #42A0FF;
			}	
			.page-title	{
				font-size: 16px;
				color: #222222;
				line-height: 24px;
				position: absolute;
				left:25%;
				margin-top: 12px;
			}
		}

		.headerWithoutBar {
			top: 82px !important;
		}

		.headerWith1Bar {
			top: 129px !important;
		}

		.headerWith2Bar {
			top: 176px !important;
		}

		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			top: 140px;
			bottom: 0px;
			overflow: hidden;

			.content-container {
				// background: #f1f2f7;
				flex:1;
				// position: absolute;
				// right: 0px;
				// top: 0px;
				// bottom: 0px;
				// left: 230px;
				overflow-y: scroll;
				padding: 30px;
				margin-top: -10px;
				.breadcrumb-container {
					//margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
				.content-wrapper-info {
					background-color: #F5F8FA;
					box-sizing: border-box;
				}
			}
		}
	}

	.alert-pre-line .el-message-box__message {
			white-space: pre-line;
		}
</style>


// WEBPACK FOOTER //
// Home.vue?07bcb7e0